<template>
  <div class="min-w-[32px] bg-pink1 px-1 py-[2px]">
    <p class="text-center text-xs tracking-normal text-red1">
      {{ requiredText[lang] }}
    </p>
  </div>
</template>

<script setup lang="ts">
import type { Lang } from '@/models/lang';
import { requiredText } from '@/models/lang';

interface Props {
  lang?: Lang;
}
withDefaults(defineProps<Props>(), {
  lang: 'jp',
});
</script>
